class INTENT.widgets.CreativeUpdateWarning

  @ATTR_NAME: "data-widget-creative-on-update-warn"

  @ATTR_ACTIVE_CAMPAIGNS: "data-active-campaigns-with-this-creative"
  @ATTR_IS_CREATIVE_MODERATOR: "data-is-creative-moderator"
  @ATTR_ACTIVE_CAMPAIGNS_TARGET: "data-active-campaigns-with-this-creative-target"
  @ATTR_IS_ORD_CONFIRM_TEXT: "data-update-confirm-ord-version"

  @SELECTOR_EDIT_FORM: '#main_form'

  @forcedUpdate = no
  @form = null

  constructor: (@el) ->
    @s = @.constructor

    @form = $ @s.SELECTOR_EDIT_FORM

    activeCampaigns = []
    if @el.is "[#{@s.ATTR_ACTIVE_CAMPAIGNS_TARGET}]"
      activeCampaigns = JSON.parse($ @el.attr "#{@s.ATTR_ACTIVE_CAMPAIGNS_TARGET}"
        .attr @s.ATTR_ACTIVE_CAMPAIGNS
      )

    activeCampaigns = _.filter activeCampaigns, (item) ->
      return item.is_only

    @el.on 'click', (e) =>
      submitButtonName = 'apply_data'
      if e.currentTarget.name
        submitButtonName = e.currentTarget.name

      errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm()
      if errorTextValidateCreativeForm != ''
        INTENT.utils.Forms.disable_submit_buttons_loader()
        return

      if @s.forcedUpdate
        return
      e.preventDefault()
      @initModal activeCampaigns, submitButtonName

  initModal: (activeCampaigns, submitButtonName = 'apply_data') =>
    rows = []
    tpl = INTENT.utils.Template
    is_moderator = if parseInt(@el.attr "#{@s.ATTR_IS_CREATIVE_MODERATOR}") == 1 then on else no
    postfixConfirmTextByORD = if parseInt(@el.attr "#{@s.ATTR_IS_ORD_CONFIRM_TEXT}") == 1 then '_ord' else '_no_ord'
    modalSettings =
      title: __('creative_update_warning_title')
      body: tpl.wrap_in_p (if is_moderator then __('creative_update_premoderation_warning_for_moderators') else __('creative_update_premoderation_warning'+postfixConfirmTextByORD))
      size: 'large'
      buttons: [
        attr:
          class: "cr-forced-update btn btn-danger pull-left"
          type: "button"
        click: =>
          @forcedUpdate = on
          $('.cr-forced-update').showLoader()
          @form.append $("<input/>", {type: 'hidden', name: submitButtonName, value: '.'})
          @form.submit()
        text: __('send_to_moderation_and_stop_serve'+postfixConfirmTextByORD)
      ]
      onClose: () =>
        INTENT.utils.Forms.disable_submit_buttons_loader()


    if not _.size activeCampaigns
      return INTENT.utils.Modal.show modalSettings

    $.each activeCampaigns, (id, cmp) ->
      if 'id' of cmp and 'name' of cmp and 'ar' of cmp
        td = ''
        td += tpl.get_td_row "##{cmp.id}", {style: 'width:20%;'}
        td += tpl.get_td_row(tpl.wrap_link "/campaigns/advertisers/#{cmp.ar}/campaigns/edit/#{cmp.id}", cmp.name, '', '_blank')
        rows.push tpl.get_tr_row td

    headRows = [
      tpl.get_td_row "<strong>id</strong>", {style: 'width:20%;'}
      tpl.get_td_row "<strong>#{__('name')}</strong>"
    ].join('')

    body = [
      tpl.wrap_in_p __('active_campaigns_with_this_creative')
      tpl.get_table(headRows, rows.join(''))
    ]

    modalSettings.buttons[0].text = __('send_to_moderation_and_stop_campaigns')
    modalSettings.body += body.join ""
    INTENT.utils.Modal.show modalSettings


